(function () {
  const config = window.RK_CONFIG || {};
  const variants = config.variants || {};
  const endpoint = config.endpoint || '';

  if (!document.getElementById('rk-drawer')) return;

  let cartItems = [];
  const cache = {};
  let currentStep = 1;
  let totalSteps = 6;

  const drawer = document.getElementById('rk-drawer');
  const panel = drawer.querySelector('.rk-panel');
  const canvas = document.getElementById('rk-canvas');
  const sideList = document.getElementById('rk-side-list');

  const formEls = {
    form: document.getElementById('rk-form'),
    info: document.getElementById('rk-form-info'),
    rect: document.getElementById('rk-fields-rect'),
    line: document.getElementById('rk-fields-line'),
    free: document.getElementById('rk-fields-free'),
    draw: document.getElementById('rk-fields-draw'),
    round: document.getElementById('rk-fields-round'),
    autoSummary: document.getElementById('rk-auto-summary')
  };

  function updateCanvasViewBox() {
    const rect = canvas.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    canvas.setAttribute('viewBox', `0 0 ${rect.width} ${rect.height}`);
  }

  let drawPoints = [{ x: 100, y: 160 }, { x: 300, y: 160 }];
  let selectedPointIndex = null;
  let draggingPointIndex = null;
  let lastCreatedPointIndex = null;

  function money(n) {
    return Number(n || 0).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function meters(n) {
    const clean = Math.round(Number(n || 0) * 100) / 100;
    return clean.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' m';
  }

  function num(v) {
    return parseFloat(String(v || '').replace(',', '.')) || 0;
  }

  function intNum(v) {
    return parseInt(v, 10) || 0;
  }

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;');
  }

  async function price(id) {
    if (cache[id]) return cache[id];
    const r = await fetch('/variants/' + id + '.js');
    if (!r.ok) throw new Error('Preis konnte nicht geladen werden');
    const d = await r.json();
    cache[id] = d.price / 100;
    return cache[id];
  }

  async function getLengthPrices(width) {
    return {
      1: await price(variants.rasen[1][width]),
      0.5: await price(variants.rasen[0.5][width]),
      0.30: await price(variants.rasen[0.30][width])
    };
  }

  function lockBody() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.classList.add('rk-lock');
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';
    }
  }

  function unlockBody() {
    document.body.classList.remove('rk-lock');
    document.body.style.paddingRight = '';
  }

  function openDrawer() {
    if (drawer.classList.contains('is-visible')) return;
    lockBody();
    drawer.classList.add('is-visible');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        updateCanvasViewBox();
        redrawCanvas();
      });
    });
  }

  function closeDrawer() {
    if (!drawer.classList.contains('is-visible')) return;
    drawer.classList.remove('is-open');

    const finishClose = () => {
      drawer.classList.remove('is-visible');
      unlockBody();
    };

    panel.addEventListener('transitionend', function handler(e) {
      if (e.target !== panel) return;
      panel.removeEventListener('transitionend', handler);
      finishClose();
    });

    setTimeout(() => {
      if (!drawer.classList.contains('is-open') && drawer.classList.contains('is-visible')) {
        finishClose();
      }
    }, 320);
  }

  function getDrawType() {
    return document.getElementById('rk-draw-type').value;
  }

  function getCanvasCoords(e) {
    const rect = canvas.getBoundingClientRect();
    const vb = canvas.viewBox.baseVal;
    return {
      x: ((e.clientX - rect.left) / rect.width) * vb.width,
      y: ((e.clientY - rect.top) / rect.height) * vb.height
    };
  }

  function angleDeg(a, b, c) {
    const ab = [a.x - b.x, a.y - b.y];
    const cb = [c.x - b.x, c.y - b.y];
    const dot = ab[0] * cb[0] + ab[1] * cb[1];
    const lab = Math.sqrt(ab[0] * ab[0] + ab[1] * ab[1]);
    const lcb = Math.sqrt(cb[0] * cb[0] + cb[1] * cb[1]);
    if (!lab || !lcb) return 0;
    const value = Math.max(-1, Math.min(1, dot / (lab * lcb)));
    return Math.acos(value) * 180 / Math.PI;
  }

  function linesIntersect(a, b, c, d) {
    function ccw(p1, p2, p3) {
      return (p3.y - p1.y) * (p2.x - p1.x) > (p2.y - p1.y) * (p3.x - p1.x);
    }
    return (ccw(a, c, d) !== ccw(b, c, d) && ccw(a, b, c) !== ccw(a, b, d));
  }

  function distancePointToSegment(p, a, b) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const len2 = dx * dx + dy * dy;
    if (len2 === 0) return Infinity;

    let t = ((p.x - a.x) * dx + (p.y - a.y) * dy) / len2;
    t = Math.max(0, Math.min(1, t));

    const proj = {
      x: a.x + t * dx,
      y: a.y + t * dy
    };

    const distX = p.x - proj.x;
    const distY = p.y - proj.y;
    return Math.sqrt(distX * distX + distY * distY);
  }

  function getSegments() {
    if (drawPoints.length < 2) return [];
    const segs = [];
    for (let i = 0; i < drawPoints.length - 1; i++) {
      segs.push({ a: drawPoints[i], b: drawPoints[i + 1], index: i });
    }
    if (getDrawType() === 'closed' && drawPoints.length > 2) {
      segs.push({ a: drawPoints[drawPoints.length - 1], b: drawPoints[0], index: drawPoints.length - 1 });
    }
    return segs;
  }

  function getSideCount() {
    return getSegments().length;
  }

  function getDrawSideLengths() {
    return [...sideList.querySelectorAll('input')].map(i => num(i.value));
  }

  function countRightAngleCornersFromPoints() {
    if (drawPoints.length < 3) return 0;
    const TOL = 5;
    const closed = getDrawType() === 'closed';
    let count = 0;

    if (closed) {
      const n = drawPoints.length;
      for (let i = 0; i < n; i++) {
        const prev = drawPoints[(i - 1 + n) % n];
        const curr = drawPoints[i];
        const next = drawPoints[(i + 1) % n];
        const ang = angleDeg(prev, curr, next);
        if (Math.abs(ang - 90) <= TOL) count++;
      }
    } else {
      for (let i = 1; i < drawPoints.length - 1; i++) {
        const ang = angleDeg(drawPoints[i - 1], drawPoints[i], drawPoints[i + 1]);
        if (Math.abs(ang - 90) <= TOL) count++;
      }
    }
    return count;
  }

  function shapeHasIntersection() {
    const segs = getSegments();
    const closed = getDrawType() === 'closed';

    for (let i = 0; i < segs.length; i++) {
      for (let j = i + 1; j < segs.length; j++) {
        const a = segs[i];
        const b = segs[j];

        if (Math.abs(i - j) <= 1) continue;
        if (closed && ((i === 0 && j === segs.length - 1) || (j === 0 && i === segs.length - 1))) continue;

        if (linesIntersect(a.a, a.b, b.a, b.b)) return true;
      }
    }
    return false;
  }

  function clearSideInputErrors() {
    sideList.querySelectorAll('input').forEach(input => {
      input.classList.remove('rk-input-error');
    });
    sideList.querySelectorAll('.rk-field-error').forEach(err => err.remove());
  }

  function markSideInputError(input, msg) {
    if (!input) return;
    input.classList.add('rk-input-error');

    const existing = input.parentNode.querySelector('.rk-field-error');
    if (existing) existing.remove();

    const err = document.createElement('p');
    err.className = 'rk-field-error';
    err.textContent = msg;
    input.parentNode.appendChild(err);
  }

  function hideAllErrors() {
    document.querySelectorAll('.rk-step .rk-error').forEach(box => {
      box.style.display = 'none';
      box.innerHTML = '';
    });
  }

  function getActiveStepErrorBox() {
    const activeStep = document.querySelector('.rk-step.is-active');
    if (!activeStep) return null;
    return activeStep.querySelector('.rk-error');
  }

  function showError(msg) {
    hideAllErrors();
    const e = getActiveStepErrorBox();
    if (!e) return;
    e.innerHTML = msg;
    e.style.display = 'block';
    e.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function updateFormUI() {
    const v = formEls.form.value;
    const widthWrap = document.getElementById('rk-width-wrap');

    formEls.rect.style.display = v === 'rect' ? '' : 'none';
    formEls.line.style.display = v === 'line' ? '' : 'none';
    formEls.free.style.display = v === 'free' ? '' : 'none';
    formEls.draw.style.display = v === 'draw' ? '' : 'none';
    formEls.round.style.display = v === 'round' ? '' : 'none';

    if (widthWrap) {
      widthWrap.style.display = v === 'draw' ? 'none' : '';
    }

    if (v === 'rect') formEls.info.textContent = 'Bei Rechteck / Quadrat wird der Umfang automatisch berechnet. 4 Eckstücke werden automatisch angesetzt.';
    if (v === 'line') formEls.info.textContent = 'Bei einer offenen Strecke werden 2 Endstücke automatisch angesetzt.';
    if (v === 'free') formEls.info.textContent = 'Bei freier Länge wird mit deiner Gesamtmeterzahl gerechnet. Endstücke werden bei offener Form automatisch berücksichtigt.';
    if (v === 'draw') formEls.info.textContent = 'Bei gezeichneter Form werden nur sehr nahe 90°-Winkel als Eckstücke erkannt.';
    if (v === 'round') formEls.info.textContent = 'Bei runden Formen rechnen wir mit dem Umfang. Je kleiner der Durchmesser, desto stärker werden kürzere Elemente bevorzugt.';
  }

  function getRoundThresholds(width) {
    if (String(width) === '8') return { min: 1.8, good: 2.2, medium: 3.0 };
    return { min: 2.0, good: 2.4, medium: 3.2 };
  }

  function updateRoundHint() {
    const width = document.getElementById('rk-breite').value;
    const roundBox = document.getElementById('rk-round-box');
    const roundInfo = document.getElementById('rk-round-info');
    const t = getRoundThresholds(width);

    if (width === '8') {
      roundBox.innerHTML = `8 cm Breite: technisch sinnvoll ab ca. <strong>${String(t.min).replace('.', ',')} m Durchmesser</strong>. Besonders harmonisch wirkt die Rundung ab ca. <strong>${String(t.good).replace('.', ',')} m</strong>.`;
    } else {
      roundBox.innerHTML = `12 cm Breite: technisch sinnvoll ab ca. <strong>${String(t.min).replace('.', ',')} m Durchmesser</strong>. Besonders harmonisch wirkt die Rundung ab ca. <strong>${String(t.good).replace('.', ',')} m</strong>.`;
    }

    roundInfo.textContent = 'Bei kleineren Durchmessern empfehlen wir Sonderanfertigungen oder kürzere Elemente. Für kleine Radien bevorzugt der Rechner automatisch 30 cm und 50 cm Rasenkanten.';
  }

  function computeAutoPartsOnly() {
    const form = formEls.form.value;
    if (form === 'rect') return { autoCorners: 4, autoEnds: 0 };
    if (form === 'line') return { autoCorners: 0, autoEnds: 2 };
    if (form === 'round') return { autoCorners: 0, autoEnds: 0 };
    if (form === 'free') {
      const type = document.getElementById('rk-free-type').value;
      return { autoCorners: 0, autoEnds: type === 'open' ? 2 : 0 };
    }
    if (form === 'draw') {
      return {
        autoCorners: countRightAngleCornersFromPoints(),
        autoEnds: getDrawType() === 'open' ? 2 : 0
      };
    }
    return { autoCorners: 0, autoEnds: 0 };
  }

  function updateAutoSummary() {
    const auto = computeAutoPartsOnly();
    const extraCorners = intNum(document.getElementById('rk-extra-ecken').value);
    const extraEnds = intNum(document.getElementById('rk-extra-end').value);

    formEls.autoSummary.innerHTML =
      `Automatisch erkannt: <strong>${auto.autoCorners}</strong> Eckstücke · <strong>${auto.autoEnds}</strong> Endstücke` +
      ((extraCorners || extraEnds)
        ? `<br>Zusätzlich eingetragen: <strong>${extraCorners}</strong> Eckstücke · <strong>${extraEnds}</strong> Endstücke`
        : '');
  }

  function rebuildSideInputs(preserveValues = true) {
    const count = getSideCount();
    const oldValues = preserveValues
      ? [...sideList.querySelectorAll('input')].map(i => i.value)
      : [];

    sideList.innerHTML = '';

    if (count === 0) return;

    const grid = document.createElement('div');
    grid.className = 'rk-side-grid';

    for (let i = 0; i < count; i++) {
      const row = document.createElement('div');
      row.className = 'rk-side-row';
      row.innerHTML = `<div class="rk-side-label">Seite ${i + 1}</div><input type="text" inputmode="decimal" placeholder="Meter" value="${oldValues[i] || ''}">`;
      grid.appendChild(row);
    }

    sideList.appendChild(grid);
    updateAutoSummary();
  }
  function syncWidthSelects(source = 'main') {
    const main = document.getElementById('rk-breite');
    const draw = document.getElementById('rk-breite-draw');
    if (!main || !draw) return;

    if (source === 'draw') {
      main.value = draw.value;
    } else {
      draw.value = main.value;
    }

    updateRoundHint();
    updateAutoSummary();
  }
  function appendCanvasLine(a, b) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', a.x);
    line.setAttribute('y1', a.y);
    line.setAttribute('x2', b.x);
    line.setAttribute('y2', b.y);
    line.setAttribute('stroke', '#111');
    line.setAttribute('stroke-width', '4');
    line.setAttribute('stroke-linecap', 'round');
    canvas.appendChild(line);
  }

  function drawSideLabel(a, b, index) {
    const mx = (a.x + b.x) / 2;
    const my = (a.y + b.y) / 2;
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const len = Math.sqrt(dx * dx + dy * dy) || 1;
    const ox = -(dy / len) * 18;
    const oy = (dx / len) * 18;

    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.setAttribute('x', mx + ox);
    text.setAttribute('y', my + oy);
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('dominant-baseline', 'middle');
    text.setAttribute('class', 'rk-side-text');
    text.textContent = 'S' + (index + 1);
    canvas.appendChild(text);
  }

  function applySmartSnap(index) {
    const p = drawPoints[index];
    if (!p) return;
    const SNAP = 18;
    const prev = index > 0 ? drawPoints[index - 1] : null;
    const next = index < drawPoints.length - 1 ? drawPoints[index + 1] : null;

    if (prev) {
      if (Math.abs(p.x - prev.x) < SNAP) p.x = prev.x;
      if (Math.abs(p.y - prev.y) < SNAP) p.y = prev.y;
    }
    if (next) {
      if (Math.abs(p.x - next.x) < SNAP) p.x = next.x;
      if (Math.abs(p.y - next.y) < SNAP) p.y = next.y;
    }

    if (getDrawType() === 'closed' && drawPoints.length > 2) {
      const first = drawPoints[0];
      const last = drawPoints[drawPoints.length - 1];

      if (index === 0) {
        if (Math.abs(p.x - last.x) < SNAP) p.x = last.x;
        if (Math.abs(p.y - last.y) < SNAP) p.y = last.y;
      }
      if (index === drawPoints.length - 1) {
        if (Math.abs(p.x - first.x) < SNAP) p.x = first.x;
        if (Math.abs(p.y - first.y) < SNAP) p.y = first.y;
      }
    }
  }

  function redrawCanvas() {
    canvas.innerHTML = '';
    const segs = getSegments();

    segs.forEach(seg => {
      appendCanvasLine(seg.a, seg.b);
      drawSideLabel(seg.a, seg.b, seg.index);
    });

    drawPoints.forEach((p, idx) => {
      const point = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      point.setAttribute('cx', p.x);
      point.setAttribute('cy', p.y);
      point.setAttribute('r', window.innerWidth < 768 ? '9' : '11');
      point.setAttribute('fill', idx === selectedPointIndex ? '#000' : '#666');
      point.setAttribute('class', 'rk-point');
      canvas.appendChild(point);
    });

    drawPoints.forEach((p, idx) => {
      const hit = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      hit.setAttribute('cx', p.x);
      hit.setAttribute('cy', p.y);
      hit.setAttribute('r', window.innerWidth < 768 ? '26' : '28');
      hit.setAttribute('fill', 'transparent');
      hit.setAttribute('class', 'rk-hit');

      hit.addEventListener('pointerdown', e => {
        e.preventDefault();
        canvas.setPointerCapture?.(e.pointerId);
        draggingPointIndex = idx;
        selectedPointIndex = idx;
        redrawCanvas();
        updateAutoSummary();
      });

      hit.addEventListener('click', e => {
        e.preventDefault();
        selectedPointIndex = idx;
        redrawCanvas();
        updateAutoSummary();
      });

      canvas.appendChild(hit);
    });
  }

  function scalePointsForPlan(points) {
    if (!points || !points.length) return null;
    const xs = points.map(p => p.x);
    const ys = points.map(p => p.y);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const w = Math.max(maxX - minX, 1);
    const h = Math.max(maxY - minY, 1);
    const boxW = 280;
    const boxH = 240;
    const padX = 70;
    const padY = 90;
    const scale = Math.min(boxW / w, boxH / h);

    return points.map(p => ({
      x: padX + (p.x - minX) * scale,
      y: padY + (p.y - minY) * scale
    }));
  }

  function rectPlanPoints(L, B) {
    const maxW = 280;
    const maxH = 220;
    const scale = Math.min(maxW / Math.max(L, 0.001), maxH / Math.max(B, 0.001));
    const w = L * scale;
    const h = B * scale;
    const x = 210 - w / 2;
    const y = 210 - h / 2;

    return [
      { x, y },
      { x: x + w, y },
      { x: x + w, y: y + h },
      { x, y: y + h }
    ];
  }

  function expandComboPieces(combo) {
    const pieces = combo?.pieces || combo || {};
    const arr = [];

    const count1 = Number(pieces[1] || pieces['1'] || 0);
    const count05 = Number(pieces[0.5] || pieces['0.5'] || 0);
    const count03 = Number(pieces[0.30] || pieces['0.30'] || pieces['0.3'] || 0);

    for (let i = 0; i < count1; i++) arr.push(1);
    for (let i = 0; i < count05; i++) arr.push(0.5);
    for (let i = 0; i < count03; i++) arr.push(0.3);

    return arr;
  }

  function getCornerIndexesForPlan(points, closed) {
    const TOL = 5;
    const indexes = [];
    if (!points || points.length < 3) return indexes;

    if (closed) {
      const n = points.length;
      for (let i = 0; i < n; i++) {
        const prev = points[(i - 1 + n) % n];
        const curr = points[i];
        const next = points[(i + 1) % n];
        const ang = angleDeg(prev, curr, next);
        if (Math.abs(ang - 90) <= TOL) indexes.push(i);
      }
    } else {
      for (let i = 1; i < points.length - 1; i++) {
        const ang = angleDeg(points[i - 1], points[i], points[i + 1]);
        if (Math.abs(ang - 90) <= TOL) indexes.push(i);
      }
    }

    return indexes;
  }

  function renderCornerSymbol(parts, prev, curr, next) {
    const arm = 18;

    const v1x = prev.x - curr.x;
    const v1y = prev.y - curr.y;
    const l1 = Math.sqrt(v1x * v1x + v1y * v1y) || 1;
    const u1x = v1x / l1;
    const u1y = v1y / l1;

    const v2x = next.x - curr.x;
    const v2y = next.y - curr.y;
    const l2 = Math.sqrt(v2x * v2x + v2y * v2y) || 1;
    const u2x = v2x / l2;
    const u2y = v2y / l2;

    parts.push(`<line x1="${curr.x}" y1="${curr.y}" x2="${curr.x + u1x * arm}" y2="${curr.y + u1y * arm}" class="rk-plan-corner-arm"></line>`);
    parts.push(`<line x1="${curr.x}" y1="${curr.y}" x2="${curr.x + u2x * arm}" y2="${curr.y + u2y * arm}" class="rk-plan-corner-arm"></line>`);
    parts.push(`<circle cx="${curr.x}" cy="${curr.y}" r="3.5" class="rk-plan-corner-dot"></circle>`);
  }

  function renderEndSymbol(parts, a, b, isStart) {
    const size = 16;
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const len = Math.sqrt(dx * dx + dy * dy) || 1;
    const ux = dx / len;
    const uy = dy / len;
    const px = isStart ? a.x : b.x;
    const py = isStart ? a.y : b.y;
    const x1 = px - ux * size / 2;
    const y1 = py - uy * size / 2;
    const x2 = px + ux * size / 2;
    const y2 = py + uy * size / 2;
    parts.push(`<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" class="rk-plan-end"></line>`);
  }

  function renderPieceSegmentsOnLine(parts, a, b, pieces) {
    if (!pieces || !pieces.length) return;

    const totalPieces = pieces.length;
    const dx = (b.x - a.x) / totalPieces;
    const dy = (b.y - a.y) / totalPieces;
    const gapRatio = 0.14;

    if (totalPieces > 12) {
      for (let i = 0; i < totalPieces; i++) {
        const piece = pieces[i];
        const cls = piece === 1 ? 'rk-p100' : piece === 0.5 ? 'rk-p50' : 'rk-p30';
        const cx = a.x + dx * (i + 0.5);
        const cy = a.y + dy * (i + 0.5);
        parts.push(`<circle cx="${cx}" cy="${cy}" r="3.2" class="rk-plan-point ${cls}"></circle>`);
      }
      return;
    }

    for (let i = 0; i < totalPieces; i++) {
      const piece = pieces[i];
      const cls = piece === 1 ? 'rk-p100' : piece === 0.5 ? 'rk-p50' : 'rk-p30';

      const sx = a.x + dx * i;
      const sy = a.y + dy * i;
      const ex = a.x + dx * (i + 1);
      const ey = a.y + dy * (i + 1);

      const cutX = dx * gapRatio;
      const cutY = dy * gapRatio;

      const x1 = sx + cutX;
      const y1 = sy + cutY;
      const x2 = ex - cutX;
      const y2 = ey - cutY;

      parts.push(`<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" class="rk-plan-piece ${cls}"></line>`);
    }
  }

  function renderShapeSvg(points, sideCombos, closed, cornerIndexes) {
    if (!points || !points.length) return '';
    const parts = [];
    parts.push(`<svg viewBox="0 0 420 420" class="rk-plan-svg">`);

    for (let i = 0; i < sideCombos.length; i++) {
      const a = points[i];
      const b = closed ? points[(i + 1) % points.length] : points[i + 1];
      if (!b) continue;

      renderPieceSegmentsOnLine(parts, a, b, sideCombos[i] || []);

      if (!closed && i === 0) renderEndSymbol(parts, a, b, true);
      if (!closed && i === sideCombos.length - 1) renderEndSymbol(parts, a, b, false);

      const mx = (a.x + b.x) / 2;
      const my = (a.y + b.y) / 2;
      const dx = b.x - a.x;
      const dy = b.y - a.y;
      const len = Math.sqrt(dx * dx + dy * dy) || 1;
      const ox = -(dy / len) * 18;
      const oy = (dx / len) * 18;

      parts.push(`<text x="${mx + ox}" y="${my + oy}" text-anchor="middle" font-size="14" font-weight="700" fill="#333">S${i + 1}</text>`);
    }

    (cornerIndexes || []).forEach(i => {
      const prev = closed ? points[(i - 1 + points.length) % points.length] : points[Math.max(0, i - 1)];
      const curr = points[i];
      const next = closed ? points[(i + 1) % points.length] : points[Math.min(points.length - 1, i + 1)];
      if (prev && curr && next) renderCornerSymbol(parts, prev, curr, next);
    });

    parts.push(`</svg>`);
    return parts.join('');
  }

  function polarToCartesian(cx, cy, r, angleDegValue) {
    const rad = (angleDegValue - 90) * Math.PI / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }

  function arcPath(cx, cy, r, startAngle, endAngle) {
    const start = polarToCartesian(cx, cy, r, endAngle);
    const end = polarToCartesian(cx, cy, r, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
  }

  function renderRoundSvg(comboPieces) {
    const total = Math.max(comboPieces.reduce((s, v) => s + v, 0), 0.0001);
    const cx = 210;
    const cy = 210;
    const r = 120;
    const parts = [];
    parts.push(`<svg viewBox="0 0 420 420" class="rk-plan-svg">`);

    if (comboPieces.length > 12) {
      let cursor = 0;
      comboPieces.forEach(piece => {
        const start = cursor / total;
        const end = (cursor + piece) / total;
        const mid = (start + end) / 2;
        const angle = mid * 360;
        const pt = polarToCartesian(cx, cy, r, angle);
        const cls = piece === 1 ? 'rk-p100' : piece === 0.5 ? 'rk-p50' : 'rk-p30';
        parts.push(`<circle cx="${pt.x}" cy="${pt.y}" r="3.2" class="rk-plan-point ${cls}"></circle>`);
        cursor += piece;
      });
      parts.push(`</svg>`);
      return parts.join('');
    }

    let currentAngle = 0;
    comboPieces.forEach(piece => {
      const angleSpan = 360 * (piece / total);
      const rawStart = currentAngle;
      const rawEnd = currentAngle + angleSpan;
      const gap = Math.min(angleSpan * 0.12, 4);
      const start = rawStart + gap / 2;
      const end = rawEnd - gap / 2;
      const cls = piece === 1 ? 'rk-p100' : piece === 0.5 ? 'rk-p50' : 'rk-p30';
      parts.push(`<path d="${arcPath(cx, cy, r, start, end)}" class="rk-plan-piece ${cls}" fill="none"></path>`);
      currentAngle = rawEnd;
    });

    parts.push(`</svg>`);
    return parts.join('');
  }

  function renderLegend(showCorner, showEnd) {
    return `<div class="rk-plan-legend">
      <span><span class="rk-plan-box rk-b100"></span>100 cm</span>
      <span><span class="rk-plan-box rk-b50"></span>50 cm</span>
      <span><span class="rk-plan-box rk-b30"></span>30 cm</span>
      ${showCorner ? `<span><span class="rk-plan-dot"></span>Eckstück</span>` : ''}
      ${showEnd ? `<span><span class="rk-plan-box" style="background:#555"></span>Endstück</span>` : ''}
    </div>`;
  }

  function chipHtml(piece) {
    if (piece === 'E') return `<span class="rk-chip e">ECK</span>`;
    if (piece === 'END') return `<span class="rk-chip end">END</span>`;
    if (piece === 1) return `<span class="rk-chip p100">100</span>`;
    if (piece === 0.5) return `<span class="rk-chip p50">50</span>`;
    return `<span class="rk-chip p30">30</span>`;
  }

  function renderRows(planRows) {
    let html = `<div class="rk-plan-rows">`;
    planRows.forEach((row, index) => {
      html += `<div class="rk-plan-row"><strong>S${index + 1}</strong><br>`;
      row.forEach(piece => {
        html += chipHtml(piece);
      });
      html += `</div>`;
    });
    html += `</div>`;
    return html;
  }

  function renderPlan(result) {
    const planWrap = document.getElementById('rk-plan');
    planWrap.innerHTML = '';
    if (!result || !result.sideCombos || !result.sideCombos.length) return;

    let html = `<div class="rk-result-details">
      <details class="rk-help rk-result-toggle">
        <summary>Verlegeplan anzeigen</summary>
        <div class="rk-help-content rk-plan-wrap">
          <div class="rk-plan-title">Grafischer Verlegeplan</div>`;

    if (result.geom.planKind === 'round') {
      const comboPieces = expandComboPieces(result.sideCombos[0]);
      html += renderRoundSvg(comboPieces);
      html += renderLegend(false, false);
      html += renderRows([comboPieces]);
      html += `<p class="rk-info" style="margin-top:12px">Der Plan zeigt jede einzelne Rasenkante. Ab mehr als 12 Segmenten werden zur besseren Lesbarkeit Punkte dargestellt.</p>`;
    }

    else if (result.geom.planKind === 'shape') {
      let scaledPoints = null;

      if (result.geom.form === 'rect') {
        const L = num(document.getElementById('rk-rect-length').value);
        const B = num(document.getElementById('rk-rect-width').value);
        scaledPoints = rectPlanPoints(L, B);
      } else if (result.geom.basePointsForPlan?.length) {
        scaledPoints = scalePointsForPlan(result.geom.basePointsForPlan);
      }

      if (scaledPoints) {
        const cornerIndexes = result.geom.form === 'rect'
          ? scaledPoints.map((_, i) => i)
          : getCornerIndexesForPlan(scaledPoints, true);

        const planRows = result.sideCombos.map((combo, index) => {
          const row = [];
          const nextIndex = (index + 1) % scaledPoints.length;
          if (cornerIndexes.includes(index)) row.push('E');
          row.push(...expandComboPieces(combo));
          if (cornerIndexes.includes(nextIndex)) row.push('E');
          return row;
        });

        html += renderShapeSvg(
          scaledPoints,
          result.sideCombos.map(c => expandComboPieces(c)),
          true,
          cornerIndexes
        );
        html += renderLegend(cornerIndexes.length > 0, false);
        html += renderRows(planRows);
      }
    }

    else if (result.geom.planKind === 'polyline' && result.geom.basePointsForPlan?.length) {
      const pts = scalePointsForPlan(result.geom.basePointsForPlan);
      const cornerIndexes = getCornerIndexesForPlan(pts, false);
      const lastIndex = result.sideCombos.length - 1;

      const planRows = result.sideCombos.map((combo, index) => {
        const row = [];

        if (result.geom.totalEnds > 0 && index === 0) row.push('END');
        else if (cornerIndexes.includes(index)) row.push('E');

        row.push(...expandComboPieces(combo));

        if (result.geom.totalEnds > 0 && index === lastIndex) row.push('END');
        else if (cornerIndexes.includes(index + 1)) row.push('E');

        return row;
      });

      html += renderShapeSvg(
        pts,
        result.sideCombos.map(c => expandComboPieces(c)),
        false,
        cornerIndexes
      );
      html += renderLegend(cornerIndexes.length > 0, result.geom.totalEnds > 0);
      html += renderRows(planRows);
    }

    else {
      const hasEnds = result.geom.totalEnds > 0;
      const planRows = result.sideCombos.map((combo, index) => {
        const row = [];
        if (hasEnds && index === 0) row.push('END');
        row.push(...expandComboPieces(combo));
        if (hasEnds && index === result.sideCombos.length - 1) row.push('END');
        return row;
      });

      const pts = [{ x: 60, y: 210 }, { x: 360, y: 210 }];

      html += renderShapeSvg(
        pts,
        [expandComboPieces(result.sideCombos[0])],
        false,
        []
      );
      html += renderLegend(false, hasEnds);
      html += renderRows(planRows);
    }

    html += `
        </div>
      </details>
    </div>`;

    planWrap.innerHTML = html;
  }

  function bindDetailsSmoothScroll() {
    const content = document.querySelector('.rk-content');
    if (!content) return;

    content.querySelectorAll('details').forEach(detailsEl => {
      detailsEl.addEventListener('toggle', function () {
        if (!this.open) return;

        requestAnimationFrame(() => {
          const contentRect = content.getBoundingClientRect();
          const elRect = this.getBoundingClientRect();
          const offset = 16;

          const targetTop =
            content.scrollTop +
            (elRect.top - contentRect.top) -
            offset;

          content.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth'
          });
        });
      });
    });
  }

  function getStepEls() {
    return [...document.querySelectorAll('.rk-step')];
  }

  function updateStepUI() {
    const steps = getStepEls();
    totalSteps = steps.length;

    steps.forEach((step, index) => {
      const stepNumber = index + 1;
      step.classList.toggle('is-active', stepNumber === currentStep);
    });

    const currentEl = document.getElementById('rk-step-current');
    const totalEl = document.getElementById('rk-step-total');
    const progressBar = document.getElementById('rk-progress-bar');
    const prevBtn = document.getElementById('rk-prev-step');
    const nextBtn = document.getElementById('rk-next-step');
    const calcBtn = document.getElementById('rk-calc');
    const restartFooterBtn = document.getElementById('rk-restart-footer');
    const isResultStep = currentStep === totalSteps;
    const isLastInputStep = currentStep === totalSteps - 1;
    const stepTop = document.querySelector('.rk-step-top');

    if (stepTop) {
      stepTop.style.display = isResultStep ? 'none' : '';
    }

    let displayStep = currentStep;
    let displayTotal = totalSteps - 1;

    if (formEls.form.value === 'round') {
      displayTotal = (totalSteps - 1) - 1;
      if (currentStep > 3) displayStep = currentStep - 1;
    }

    if (currentEl) currentEl.textContent = displayStep;
    if (totalEl) totalEl.textContent = displayTotal;

    if (progressBar) {
      const progressPercent = displayTotal > 1
        ? ((displayStep - 1) / (displayTotal - 1)) * 100
        : 0;

      progressBar.style.width = `${Math.max(0, Math.min(100, progressPercent))}%`;
    }

    if (prevBtn) {
      prevBtn.disabled = currentStep === 1;
      prevBtn.style.display = '';
    }

    if (restartFooterBtn) {
      restartFooterBtn.style.display = isResultStep ? '' : 'none';
    }

    if (nextBtn) {
      if (isResultStep) {
        nextBtn.style.display = 'none';
      } else {
        nextBtn.style.display = '';
        nextBtn.textContent = isLastInputStep ? 'Berechnen' : 'Weiter';
      }
    }

    if (calcBtn) {
      calcBtn.style.display = 'none';
    }

    hideAllErrors();

    const content = document.querySelector('.rk-content');
    if (content) content.scrollTop = 0;
  }

  function nextStep() {
    if (currentStep < totalSteps) {
      currentStep++;
      if (currentStep === 3 && formEls.form.value === 'round') currentStep = 4;
      updateStepUI();
    }
  }

  function prevStep() {
    if (currentStep > 1) {
      currentStep--;
      if (currentStep === 3 && formEls.form.value === 'round') currentStep = 2;
      updateStepUI();
    }
  }

  function validateCurrentStep() {
    const form = formEls.form.value;

    if (currentStep === 2) {
      if (form === 'rect') {
        const length = num(document.getElementById('rk-rect-length').value);
        const width = num(document.getElementById('rk-rect-width').value);

        if (length <= 0 && width <= 0) return showError('Bitte gib Länge und Breite ein.'), false;
        if (length <= 0) return showError('Bitte gib die Länge ein.'), false;
        if (width <= 0) return showError('Bitte gib die Breite ein.'), false;
      }

      if (form === 'line') {
        if (num(document.getElementById('rk-line-length').value) <= 0) {
          showError('Bitte gib die Länge der Strecke ein.');
          return false;
        }
      }

      if (form === 'free') {
        if (num(document.getElementById('rk-free-meter').value) <= 0) {
          showError('Bitte gib die Gesamtlänge der Rasenkante ein.');
          return false;
        }
      }

      if (form === 'round') {
        const diameter = num(document.getElementById('rk-round-diameter').value);
        const width = document.getElementById('rk-breite').value;
        const t = getRoundThresholds(width);

        if (diameter <= 0) return showError('Bitte gib den Durchmesser ein.'), false;
        if (diameter < t.min) {
          showError(`Für ${width} cm Breite sind runde Formen unter ca. ${String(t.min).replace('.', ',')} m Durchmesser nicht sinnvoll. Bitte wähle einen größeren Durchmesser oder kontaktiere uns für eine Sonderanfertigung.`);
          return false;
        }
      }

      if (form === 'draw') {
        const sideCount = getSideCount();
        const inputs = [...sideList.querySelectorAll('input')];
        const lengths = inputs.map(input => num(input.value));

        clearSideInputErrors();

        if (sideCount < 1) {
          showError('Bitte lege zuerst eine Form an.');
          return false;
        }

        let firstInvalidInput = null;

        inputs.forEach((input, index) => {
          const raw = String(input.value || '').trim();
          const value = lengths[index];

          if (raw === '') {
            markSideInputError(input, `Bitte Maß für Seite ${index + 1} eingeben.`);
            if (!firstInvalidInput) firstInvalidInput = input;
            return;
          }

          if (value <= 0) {
            markSideInputError(input, `Seite ${index + 1} muss größer als 0 sein.`);
            if (!firstInvalidInput) firstInvalidInput = input;
          }
        });

        if (firstInvalidInput) {
          firstInvalidInput.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });

          setTimeout(() => firstInvalidInput.focus(), 250);
          return false;
        }
      }
    }

    hideAllErrors();
    return true;
  }

  function resetAll() {
    document.getElementById('rk-breite').value = '8';
    const drawWidth = document.getElementById('rk-breite-draw');
    if (drawWidth) drawWidth.value = '8';
    document.getElementById('rk-rect-length').value = '';
    document.getElementById('rk-rect-width').value = '';
    const measureMode = document.getElementById('rk-measure-mode');
    if (measureMode) measureMode.value = 'inside';

    const measureModeDraw = document.getElementById('rk-measure-mode-draw');
    if (measureModeDraw) measureModeDraw.value = 'inside';
    document.getElementById('rk-line-length').value = '';
    document.getElementById('rk-free-meter').value = '';
    document.getElementById('rk-free-type').value = 'open';
    document.getElementById('rk-round-diameter').value = '';
    const roundMeasureMode = document.getElementById('rk-round-measure-mode');
    if (roundMeasureMode) roundMeasureMode.value = 'outside';
    document.getElementById('rk-draw-type').value = 'closed';
    document.getElementById('rk-extra-ecken').value = '';
    document.getElementById('rk-extra-end').value = '';
    document.getElementById('rk-mischen').value = 'ja';
    document.getElementById('rk-fix-wrap').style.display = 'none';
    document.getElementById('rk-output').innerHTML = '';
    document.getElementById('rk-plan').innerHTML = '';
    hideAllErrors();
    clearSideInputErrors();

    document.querySelectorAll('#rk-drawer details[open]').forEach(el => {
      el.open = false;
    });

    document.querySelectorAll('.rk-form-choice').forEach(x => x.classList.remove('active'));
    document.querySelector('.rk-form-choice[data-form="free"]').classList.add('active');
    formEls.form.value = 'free';

    updateFormUI();
    updateAutoSummary();

    document.querySelectorAll('.rk-curve-choice').forEach(x => x.classList.remove('active'));
    document.querySelector('.rk-curve-choice[data-k="gerade"]').classList.add('active');
    document.getElementById('rk-curve-info').textContent = 'Gerade Verläufe benötigen keine Reserve.';

    drawPoints = [{ x: 100, y: 160 }, { x: 300, y: 160 }];
    selectedPointIndex = null;
    draggingPointIndex = null;
    lastCreatedPointIndex = null;

    updateCanvasViewBox();
    redrawCanvas();
    sideList.innerHTML = '';
    rebuildSideInputs(false);
    updateAutoSummary();
    updateRoundHint();
    syncWidthSelects('main');

    cartItems = [];
    currentStep = 1;
    updateStepUI();

    requestAnimationFrame(() => {
      const content = document.querySelector('.rk-content');
      const activeStep = document.querySelector('.rk-step.is-active');
      if (!content) return;

      const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      content.scrollTop = 0;
      void content.offsetHeight;
      if (activeStep) void activeStep.offsetHeight;

      if (isIOS && activeStep) {
        activeStep.style.transform = 'translateZ(0)';
        requestAnimationFrame(() => {
          activeStep.style.transform = '';
        });
      }
    });
  }

  async function calculateViaApi(payload) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.error || 'Berechnung fehlgeschlagen.');
    }

    return result;
  }

function buildLocalGeometry(payload) {
  const form = payload.form;

  const widthCm = num(payload.width || 8);
  const measureMode = payload.measureMode || 'inside';

  const cornerCover = measureMode === 'inside'
    ? Math.max(0, 0.30 - (widthCm / 100))
    : 0.30;

  const endCover = 0.30;

  let perimeter = 0;
  let autoCorners = 0;
  let autoEnds = 0;
  let sideTargets = [];
  let displayStraightBase = 0;
  let planKind = 'line';
  let basePointsForPlan = null;
  let warnings = ['Fallback-Berechnung aktiv, weil der Server nicht erreichbar war.'];

  if (form === 'free') {
    perimeter = num(payload.freeMeter);
    autoEnds = payload.freeType === 'open' ? 2 : 0;
    displayStraightBase = Math.max(perimeter - autoEnds * 0.3, 0);
    sideTargets = [displayStraightBase];
    planKind = 'line';
  }

  if (form === 'line') {
    perimeter = num(payload.lineLength);
    autoEnds = 2;
    displayStraightBase = Math.max(perimeter - 2 * endCover, 0);
    sideTargets = [displayStraightBase];
    planKind = 'line';
  }

  if (form === 'rect') {
    const L = num(payload.rectLength);
    const B = num(payload.rectWidth);
    const deductionPerSide = 2 * cornerCover;

    perimeter = 2 * (L + B);
    autoCorners = 4;
    sideTargets = [
      Math.max(L - deductionPerSide, 0),
      Math.max(B - deductionPerSide, 0),
      Math.max(L - deductionPerSide, 0),
      Math.max(B - deductionPerSide, 0)
    ];
    displayStraightBase = sideTargets.reduce((a, b) => a + b, 0);
    planKind = 'shape';
  }

  if (form === 'round') {
    const Dinput = num(payload.roundDiameter);
    const roundMeasureMode = payload.roundMeasureMode || 'outside';
    let D = Dinput;

    if (roundMeasureMode === 'inside') {
      D += 2 * (widthCm / 100);
    }

    perimeter = Math.PI * D;
    displayStraightBase = perimeter;
    sideTargets = [perimeter];
    planKind = 'round';
    warnings.push(roundMeasureMode === 'inside'
      ? `Innendurchmesser wurde in Außendurchmesser umgerechnet: ${Dinput.toLocaleString('de-DE')} m innen + 2 × ${widthCm} cm = ca. ${D.toLocaleString('de-DE', { maximumFractionDigits: 2 })} m außen.`
      : 'Der eingegebene Durchmesser wird als Außendurchmesser berechnet.');
  }

  if (form === 'draw') {
    const lengths = Array.isArray(payload.drawSideLengths)
      ? payload.drawSideLengths.map(Number)
      : [];

    perimeter = lengths.reduce((a, b) => a + b, 0);
    autoCorners = countRightAngleCornersFromPoints();
    autoEnds = payload.drawType === 'open' ? 2 : 0;

    displayStraightBase = Math.max(
      perimeter - autoCorners * 0.6 - autoEnds * 0.3,
      0
    );

    sideTargets = lengths;
    planKind = payload.drawType === 'open' ? 'polyline' : 'shape';
    basePointsForPlan = Array.isArray(payload.drawPoints) ? payload.drawPoints : null;
  }

  const extraCorners = intNum(payload.extraCorners);
  const extraEnds = intNum(payload.extraEnds);

  return {
    form,
    perimeter,
    autoCorners,
    autoEnds,
    extraCorners,
    extraEnds,
    totalCorners: autoCorners + extraCorners,
    totalEnds: autoEnds + extraEnds,
    sideTargets,
    displayStraightBase,
    planKind,
    basePointsForPlan,
    warnings
  };
}


  function roundAllowedLengthsByDiameterLocal(diameter, mode, fixLen) {
    if (mode === 'nein') return [Number(fixLen || 1)];
    if (diameter < 3.0) return [0.30];
    if (diameter < 5.75) return [0.5, 0.30];
    return [1, 0.5, 0.30];
  }

  function roundExtraPerPieceLocal(diameter, overlapSide) {
    if (diameter < 3.0) return 2 * overlapSide;
    return Math.min(0.015, 2 * overlapSide);
  }

  function roundSmartComboLocal(target, payload) {
    const width = String(payload.width || '8');
    const diameterInput = num(payload.roundDiameter);
    const roundMeasureMode = payload.roundMeasureMode || 'outside';
    const widthM = Number(width) / 100;
    const diameter = roundMeasureMode === 'inside'
      ? diameterInput + 2 * widthM
      : diameterInput;
    const overlapSide = width === '12' ? 0.065 : 0.045;

    if (!diameter || target <= 0) {
      throw new Error('Bitte den Durchmesser eingeben.');
    }

    const allowedLengths = roundAllowedLengthsByDiameterLocal(diameter, payload.mode, payload.fixLen);
    const extraPerPiece = roundExtraPerPieceLocal(diameter, overlapSide);
    const minPieces = Math.ceil(360 / 20);
    const maxPieces = Math.ceil(target / 0.30) + 40;

    let best = null;
    let bestScore = Infinity;

    for (let pieceCount = minPieces; pieceCount <= maxPieces; pieceCount++) {
      for (let a = 0; a <= pieceCount; a++) {
        for (let b = 0; b <= pieceCount - a; b++) {
          const c = pieceCount - a - b;

          if (!allowedLengths.includes(1) && a > 0) continue;
          if (!allowedLengths.includes(0.5) && b > 0) continue;
          if (!allowedLengths.includes(0.30) && c > 0) continue;

          const nominalCover = a * 1 + b * 0.5 + c * 0.30;
          const maxAllowedCover = nominalCover + pieceCount * extraPerPiece;

          if (target < nominalCover - 0.0001) continue;
          if (target > maxAllowedCover + 0.0001) continue;

          let usedTypes = 0;
          if (a > 0) usedTypes++;
          if (b > 0) usedTypes++;
          if (c > 0) usedTypes++;

          let score;
          if (diameter < 3.0) {
            score = pieceCount * 100 + Math.abs(target - ((nominalCover + maxAllowedCover) / 2));
          } else {
            score =
              (usedTypes > 1 ? 5000 : 0) +
              pieceCount * 1000 +
              c * 300 +
              b * 80 +
              Math.abs(target - nominalCover) * 100;
          }

          if (score < bestScore) {
            bestScore = score;
            best = { '1': a, '0.5': b, '0.30': c, nominalCover, maxAllowedCover, extraPerPiece };
          }
        }
      }

      if (best && diameter < 3.0) break;
    }

    if (!best) throw new Error('Für diesen Durchmesser wurde keine passende runde Stückkombination gefunden.');

    const pieces = { '1': best['1'], '0.5': best['0.5'], '0.30': best['0.30'] };
    const totalLength = pieces['1'] * 1 + pieces['0.5'] * 0.5 + pieces['0.30'] * 0.30;
    const pieceCount = pieces['1'] + pieces['0.5'] + pieces['0.30'];

    return {
      pieces,
      totalLength,
      totalPrice: 0,
      overshoot: Math.max(0, totalLength - target),
      pieceCount,
      roundMeta: {
        nominalCover: best.nominalCover,
        maxAllowedCover: best.maxAllowedCover,
        extraPerPiece: best.extraPerPiece
      }
    };
  }

  function calculateLocalFallback(payload) {
  let reserve = 0;

  if (payload.curve === 'leicht') reserve = 0.05;
  if (payload.curve === 'eng') reserve = 0.08;

  const geom = buildLocalGeometry(payload);

  if (payload.form === 'round') {
    const combo = roundSmartComboLocal(geom.perimeter, payload);

    return {
      success: true,
      fallback: true,
      geom,
      reserve: 0,
      combinedPieces: combo.pieces,
      sideCombos: [combo],
      totalStraightPurchased: combo.totalLength,
      totalOvershoot: combo.overshoot,
      totalPieceCount: combo.pieceCount,
      useExactCombo: true
    };
  }

  const combinedPieces = { '1': 0, '0.5': 0, '0.30': 0 };
  const sideCombos = [];

  let totalStraightPurchased = 0;
  let totalOvershoot = 0;
  let totalPieceCount = 0;

  function addCombo(target) {
    const targetWithReserve = target * (1 + reserve);
    const pieces = { '1': 0, '0.5': 0, '0.30': 0 };

    if (payload.mode === 'nein') {
      const len = Number(payload.fixLen || 1);
      const key = len === 1 ? '1' : len === 0.5 ? '0.5' : '0.30';
      pieces[key] = Math.ceil(targetWithReserve / len);
    } else if (payload.curve === 'eng') {
      pieces['0.30'] = Math.ceil(targetWithReserve / 0.3);
    } else if (payload.curve === 'leicht') {
      pieces['0.5'] = Math.floor(targetWithReserve / 0.5);
      let rest = targetWithReserve - pieces['0.5'] * 0.5;

      if (rest > 0.001) {
        pieces['0.30'] = Math.ceil(rest / 0.3);
      }
    } else {
      pieces['1'] = Math.floor(targetWithReserve);
      let rest = targetWithReserve - pieces['1'];

      if (rest > 0.001) {
        if (rest <= 0.3) pieces['0.30'] += 1;
        else if (rest <= 0.5) pieces['0.5'] += 1;
        else if (rest <= 0.8) {
          pieces['0.5'] += 1;
          pieces['0.30'] += 1;
        } else {
          pieces['1'] += 1;
        }
      }
    }

    const totalLength =
      pieces['1'] * 1 +
      pieces['0.5'] * 0.5 +
      pieces['0.30'] * 0.3;

    const pieceCount = pieces['1'] + pieces['0.5'] + pieces['0.30'];
    const overshoot = totalLength - targetWithReserve;

    const combo = {
      pieces,
      totalLength,
      totalPrice: 0,
      overshoot,
      pieceCount
    };

    sideCombos.push(combo);

    combinedPieces['1'] += pieces['1'];
    combinedPieces['0.5'] += pieces['0.5'];
    combinedPieces['0.30'] += pieces['0.30'];

    totalStraightPurchased += totalLength;
    totalOvershoot += overshoot;
    totalPieceCount += pieceCount;
  }

  geom.sideTargets.forEach(addCombo);

  return {
    success: true,
    fallback: true,
    geom,
    reserve,
    combinedPieces,
    sideCombos,
    totalStraightPurchased,
    totalOvershoot,
    totalPieceCount
  };
} async function runCalculation() {
    const btn = document.getElementById('rk-calc');
    const text = btn.querySelector('.rk-btn-text');
    const output = document.getElementById('rk-output');

    cartItems = [];
    hideAllErrors();
    btn.disabled = true;
    text.innerHTML = '<span class="rk-loading"><span class="rk-spinner"></span>Berechne optimale Stückzahl…</span>';

    output.innerHTML = `
      <div class="rk-calculating">
        <div class="rk-calculating-spinner"></div>
        <div class="rk-calculating-title">Dein Ergebnis wird berechnet</div>
        <div class="rk-calculating-text">
          Wir ermitteln gerade die optimale Stückzahl, Zubehör und den Verlegeplan.
        </div>
      </div>
    `;

    document.getElementById('rk-plan').innerHTML = '';

    try {
      const width = document.getElementById('rk-breite').value;
      const prices = await getLengthPrices(width);

      if (formEls.form.value === 'draw' && shapeHasIntersection()) {
        throw new Error('Die gezeichnete Form überschneidet sich. Bitte Punkte anpassen.');
      }

      const curve = document.querySelector('.rk-curve-choice.active').dataset.k;
      const mode = document.getElementById('rk-mischen').value;
      const fixLen = parseFloat(document.getElementById('rk-fix').value);

      const measureMode = formEls.form.value === 'draw'
        ? document.getElementById('rk-measure-mode-draw')?.value || 'inside'
        : document.getElementById('rk-measure-mode')?.value || 'inside';

      const payload = {
        form: formEls.form.value,
        width,
        measureMode,
        curve,
        mode,
        fixLen,
        prices,
        rectLength: document.getElementById('rk-rect-length').value,
        rectWidth: document.getElementById('rk-rect-width').value,
        lineLength: document.getElementById('rk-line-length').value,
        freeMeter: document.getElementById('rk-free-meter').value,
        freeType: document.getElementById('rk-free-type').value,
        roundDiameter: document.getElementById('rk-round-diameter').value,
        roundMeasureMode: document.getElementById('rk-round-measure-mode')?.value || 'outside',
        drawType: document.getElementById('rk-draw-type').value,
        drawPoints,
        drawSideLengths: getDrawSideLengths(),
        extraCorners: document.getElementById('rk-extra-ecken').value,
        extraEnds: document.getElementById('rk-extra-end').value,
        hybridExactMaxTotal: Number(config.hybridExactMaxTotal || 70)
      };

      let calcResult;

try {
  calcResult = await calculateViaApi(payload);
} catch (serverError) {
  console.warn('Server nicht erreichbar, lokaler Fallback wird genutzt:', serverError);
  calcResult = calculateLocalFallback(payload);
}
      const geom = calcResult.geom || {};
      const reserve = Number(calcResult.reserve || 0);

      const combinedPiecesRaw = calcResult.combinedPieces || {};
      const combinedPieces = {
        1: Number(combinedPiecesRaw[1] || combinedPiecesRaw['1'] || 0),
        0.5: Number(combinedPiecesRaw[0.5] || combinedPiecesRaw['0.5'] || 0),
        0.30: Number(combinedPiecesRaw[0.30] || combinedPiecesRaw['0.30'] || combinedPiecesRaw['0.3'] || 0)
      };

      const sideCombos = Array.isArray(calcResult.sideCombos) ? calcResult.sideCombos : [];
      const totalStraightPurchased = Number(calcResult.totalStraightPurchased || 0);
      const totalOvershoot = Number(calcResult.totalOvershoot || 0);
      const totalPieceCount = Number(calcResult.totalPieceCount || 0);
      const cornerCover = Number(geom.cornerCover || 0.30);
      const endCover = Number(geom.endCover || 0.30);

      const accessoryReplacedLength =
        Number(geom.totalCorners || 0) * 2 * cornerCover +
        Number(geom.totalEnds || 0) * endCover;

      const measureLabel = geom.measureMode === 'inside'
        ? 'Innenkante'
        : 'Außenkante';

      let total = 0;
      let productLinesHtml = '';

      for (const len of [1, 0.5, 0.30]) {
        const qty = combinedPieces[len] || 0;
        if (!qty) continue;

        const id = variants.rasen[len][width];
        const p = await price(id);
        const sum = p * qty;

        total += sum;
        cartItems.push({ id, quantity: qty });

        const label = Math.round(len * 100);

        productLinesHtml += `
          <div class="rk-order-line">
            <div class="rk-order-line-qty">${qty}×</div>
            <div class="rk-order-line-title">Rasenkante Cortenstahl ${label} cm × ${width} cm</div>
            <div class="rk-order-line-price">${money(sum)}</div>
          </div>
        `;
      }

      if (geom.totalCorners > 0) {
        const id = variants.ecke[width];
        const p = await price(id);
        const sum = p * geom.totalCorners;

        total += sum;
        cartItems.push({ id, quantity: geom.totalCorners });

        productLinesHtml += `
          <div class="rk-order-line">
            <div class="rk-order-line-qty">${geom.totalCorners}×</div>
            <div class="rk-order-line-title">Eckstück 30 cm × 30 cm × ${width} cm</div>
            <div class="rk-order-line-price">${money(sum)}</div>
          </div>
        `;
      }

      if (geom.totalEnds > 0) {
        const id = variants.end[width];
        const p = await price(id);
        const sum = p * geom.totalEnds;

        total += sum;
        cartItems.push({ id, quantity: geom.totalEnds });

        productLinesHtml += `
          <div class="rk-order-line">
            <div class="rk-order-line-qty">${geom.totalEnds}×</div>
            <div class="rk-order-line-title">Endstück 30 cm × ${width} cm</div>
            <div class="rk-order-line-price">${money(sum)}</div>
          </div>
        `;
      }

      const accessoryCount = Number(geom.totalCorners || 0) + Number(geom.totalEnds || 0);
      const freeShippingThreshold = 249;
      const shippingProgress = Math.min((total / freeShippingThreshold) * 100, 100);
      const shippingRemaining = Math.max(freeShippingThreshold - total, 0);

      const shippingHtml = total >= freeShippingThreshold
        ? `
          <div class="rk-shipping-box">
            <div class="rk-shipping-text">
              <strong>Du hast kostenlosen Versand erreicht.</strong>
            </div>
            <div class="rk-shipping-bar">
              <div class="rk-shipping-bar-fill" style="width:100%"></div>
            </div>
          </div>
        `
        : `
          <div class="rk-shipping-box">
            <div class="rk-shipping-text">
              Dir fehlen noch <strong>${money(shippingRemaining)}</strong> bis zum kostenlosen Versand.<br>
            </div>
            <div class="rk-shipping-bar">
              <div class="rk-shipping-bar-fill" style="width:${shippingProgress}%"></div>
            </div>
          </div>
        `;

      output.innerHTML = `
        <div class="rk-result-headline">Ergebnis</div>

        <div class="rk-order-top">
          <h3>Deine Konfiguration</h3>
          <div class="rk-order-price">${money(total)}</div>
          <div class="rk-order-sub">
            ${total >= freeShippingThreshold ? 'inkl. kostenlosem Versand' : 'zzgl. 9,90 € Versand'}<br>
            Cortenstahl · ${width} cm Breite
          </div>
        </div>

        ${shippingHtml}

        <div class="rk-order-stats">
          <div class="rk-order-stat">
            <strong>${meters(geom.perimeter)}</strong>
            <span>Gesamtlänge</span>
          </div>
          <div class="rk-order-stat">
            <strong>${meters(Number(geom.displayStraightBase || 0) * (1 + reserve))}</strong>
            <span>Rechnerisch gerade Strecke</span>
          </div>
          <div class="rk-order-stat">
            <strong>${accessoryCount}</strong>
            <span>Ecken / Enden</span>
          </div>
        </div>

        ${
          (geom.totalCorners > 0 || geom.totalEnds > 0)
            ? `
              <div class="rk-auto-box" style="margin-bottom:22px;">
              <strong>Rechnerische ${measureLabel}:</strong><br>
              ${meters(accessoryReplacedLength)} der eingegebenen ${measureLabel} werden durch
              ${geom.totalCorners > 0 ? `${geom.totalCorners} Eckstück${geom.totalCorners !== 1 ? 'e' : ''}` : ''}
              ${geom.totalCorners > 0 && geom.totalEnds > 0 ? ' und ' : ''}
              ${geom.totalEnds > 0 ? `${geom.totalEnds} Endstück${geom.totalEnds !== 1 ? 'e' : ''}` : ''}
              ersetzt.<br><br>

              <strong>Eingeplante gerade Elemente:</strong> ${meters(totalStraightPurchased)}<br>
              <strong>Anpassung / Überstand:</strong> ${meters(totalOvershoot)}
            </div>
            `
            : ''
        }

        <div class="rk-order-list">
          ${productLinesHtml}
        </div>

        <div class="rk-result-cart">
          <button id="rk-cart-result" class="button button--primary button--full" type="button">
            Alles in den Warenkorb
          </button>
        </div>

        <div class="rk-result-details">
          <details class="rk-help rk-result-toggle">
            <summary>So haben wir gerechnet</summary>
            <div class="rk-help-content">
              <p>
                <strong>Deine eingegebene Länge:</strong> ${meters(geom.perimeter)}
              </p>

              ${
                (geom.totalCorners > 0 || geom.totalEnds > 0)
                  ? `
                    <p>
                      <strong>Abzüge durch Zubehör:</strong><br>
                      ${
                        geom.totalCorners > 0
                          ? `• ${geom.totalCorners} Eckstück${geom.totalCorners !== 1 ? 'e' : ''} ersetzen rechnerisch zusammen ${meters(Number(geom.totalCorners || 0) * 2 * cornerCover)}<br>`
                          : ''
                      }
                      ${
                        geom.totalEnds > 0
                          ? `• ${geom.totalEnds} Endstück${geom.totalEnds !== 1 ? 'e' : ''} ersetzen zusammen ${meters(Number(geom.totalEnds || 0) * endCover)}<br>`
                          : ''
                      }
                      → Verbleibende gerade Strecke: <strong>${meters(geom.displayStraightBase)}</strong>
                    </p>
                  `
                  : `
                    <p>
                      <strong>Verbleibende gerade Strecke:</strong> ${meters(geom.displayStraightBase)}
                    </p>
                  `
              }

              <p>
                <strong>Reserve:</strong><br>
                ${
                  reserve > 0
                    ? `Für deinen Verlauf wurden <strong>${(reserve * 100).toFixed(1).replace('.0', '')}% Reserve</strong> eingerechnet.`
                    : `Für deinen Verlauf wurde <strong>keine zusätzliche Reserve</strong> benötigt.`
                }
              </p>

              <p>
                <strong>Rechnerisch gerade Strecke:</strong><br>
                Nach Abzug von Eckstücken und Endstücken bleiben <strong>${meters(geom.displayStraightBase)}</strong> gerade Strecke.
              </p>

              <p>
                <strong>Eingeplante gerade Elemente:</strong><br>
                In der Stückliste sind insgesamt <strong>${meters(totalStraightPurchased)}</strong> gerade Rasenkanten enthalten.
              </p>

              <p>
                <strong>Anpassung / Überstand:</strong><br>
                Dadurch entstehen <strong>${meters(totalOvershoot)}</strong> Anpassung vor Ort, da die geraden Rasenkanten nur in festen Längen erhältlich sind.
              </p>

              <p>
                <strong>Anzahl gerade Teilstücke:</strong><br>
                ${totalPieceCount}
              </p>

              <div class="rk-disclaimer-box">
                <strong>Hinweis zur Berechnung:</strong><br>
                Die berechnete Stückliste ist eine Empfehlung auf Basis Ihrer Angaben.
                Je nach Verlegung, Zuschnitt, Überlappung und örtlicher Einbausituation kann der tatsächliche Bedarf abweichen.
                Bitte prüfen Sie die Maße vor der Bestellung.
              </div>

              ${
                Array.isArray(geom.warnings) && geom.warnings.length
                  ? `<p class="rk-info">${geom.warnings.map(w => escapeHtml(w)).join('<br>')}</p>`
                  : ''
              }
            </div>
          </details>
        </div>
      `;

      renderPlan({ geom, sideCombos });
      bindDetailsSmoothScroll();

      currentStep = totalSteps;
      updateStepUI();

      const content = document.querySelector('.rk-content');
      const resultCard = document.getElementById('rk-result-card');

      if (content && resultCard) {
        const contentRect = content.getBoundingClientRect();
        const cardRect = resultCard.getBoundingClientRect();
        const targetTop = content.scrollTop + (cardRect.top - contentRect.top);
        content.scrollTop = Math.max(0, targetTop);
      }
    } catch (err) {
      showError(err.message || 'Bitte Eingaben prüfen.');
    } finally {
      btn.disabled = false;
      text.textContent = 'Berechnen';
    }
  }

  document.querySelectorAll('.rk-open').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      openDrawer();
    });
  });

  document.querySelectorAll('a[href="#konfigurator"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      openDrawer();
    });
  });

  document.querySelectorAll('[data-rk-close]').forEach(btn => {
    btn.addEventListener('click', closeDrawer);
  });

  document.querySelectorAll('.rk-form-choice').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.rk-form-choice').forEach(x => x.classList.remove('active'));
      btn.classList.add('active');
      formEls.form.value = btn.dataset.form;

      updateFormUI();
      updateAutoSummary();
      updateStepUI();

      if (btn.dataset.form === 'draw') {
        setTimeout(() => {
          updateCanvasViewBox();
          redrawCanvas();
        }, 50);
      }
    });
  });

  document.getElementById('rk-breite').addEventListener('change', () => {
    syncWidthSelects('main');
  });

  document.getElementById('rk-breite-draw').addEventListener('change', () => {
    syncWidthSelects('draw');
  });

  document.querySelectorAll('.rk-curve-choice').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.rk-curve-choice').forEach(x => x.classList.remove('active'));
      btn.classList.add('active');

      const info = document.getElementById('rk-curve-info');
      if (btn.dataset.k === 'gerade') info.textContent = 'Gerade Verläufe benötigen keine Reserve.';
      if (btn.dataset.k === 'leicht') info.textContent = 'Leichte Bögen benötigen etwas Spielraum. Wir rechnen ca. +5% Reserve ein.';
      if (btn.dataset.k === 'eng') info.textContent = 'Viele / enge Kurven benötigen mehr Flexibilität. Die Reserve wird automatisch je nach verwendeten Elementen (ca. 5–8%) berechnet.';
    });
  });

  document.getElementById('rk-mischen').addEventListener('change', function () {
    document.getElementById('rk-fix-wrap').style.display = this.value === 'nein' ? 'block' : 'none';
  });

  document.getElementById('rk-extra-ecken').addEventListener('input', updateAutoSummary);
  document.getElementById('rk-extra-end').addEventListener('input', updateAutoSummary);
  document.getElementById('rk-free-type').addEventListener('change', updateAutoSummary);

  sideList.addEventListener('input', e => {
    const input = e.target.closest('input');
    if (!input) return;
    input.classList.remove('rk-input-error');
    const err = input.parentNode.querySelector('.rk-field-error');
    if (err) err.remove();
  });

  document.getElementById('rk-draw-remove').addEventListener('click', () => {
    if (drawPoints.length <= 2) return;

    if (lastCreatedPointIndex !== null) {
      drawPoints.splice(lastCreatedPointIndex, 1);
      lastCreatedPointIndex = null;
    } else {
      drawPoints.pop();
    }

    selectedPointIndex = drawPoints.length ? drawPoints.length - 1 : null;
    redrawCanvas();
    rebuildSideInputs();
  });

  document.getElementById('rk-draw-reset').addEventListener('click', () => {
    drawPoints = [{ x: 100, y: 160 }, { x: 300, y: 160 }];
    selectedPointIndex = null;
    draggingPointIndex = null;
    lastCreatedPointIndex = null;
    redrawCanvas();
    rebuildSideInputs(false);
  });

  canvas.addEventListener('pointermove', e => {
    const pos = getCanvasCoords(e);

    if (draggingPointIndex !== null) {
      const vb = canvas.viewBox.baseVal;
      drawPoints[draggingPointIndex].x = clamp(pos.x, 20, vb.width - 20);
      drawPoints[draggingPointIndex].y = clamp(pos.y, 20, vb.height - 20);
      applySmartSnap(draggingPointIndex);
      redrawCanvas();
      updateAutoSummary();
      return;
    }

    const segs = getSegments();
    let bestIndex = -1;
    let bestDist = 16;

    redrawCanvas();

    segs.forEach(seg => {
      const dist = distancePointToSegment(pos, seg.a, seg.b);
      if (dist < bestDist) {
        bestDist = dist;
        bestIndex = seg.index;
      }
    });

    if (bestIndex !== -1) {
      const isOpen = getDrawType() === 'open';
      if (isOpen && bestIndex !== segs.length - 1) return;

      const seg = segs.find(s => s.index === bestIndex);
      const mx = (seg.a.x + seg.b.x) / 2;
      const my = (seg.a.y + seg.b.y) / 2;
      const dx = seg.b.x - seg.a.x;
      const dy = seg.b.y - seg.a.y;
      const len = Math.sqrt(dx * dx + dy * dy) || 1;
      const offset = 18;
      const px = mx + (dy / len) * offset;
      const py = my - (dx / len) * offset;

      const plus = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      plus.setAttribute('x', px);
      plus.setAttribute('y', py);
      plus.setAttribute('text-anchor', 'middle');
      plus.setAttribute('dominant-baseline', 'middle');
      plus.setAttribute('class', 'rk-plus');
      plus.textContent = '+';
      canvas.appendChild(plus);
    }
  });

  canvas.addEventListener('pointerdown', e => {
    if (e.target.classList.contains('rk-hit')) return;

    const pos = getCanvasCoords(e);
    const segs = getSegments();

    let bestIndex = -1;
    let bestDist = 20;

    segs.forEach(seg => {
      const dist = distancePointToSegment(pos, seg.a, seg.b);
      if (dist < bestDist) {
        bestDist = dist;
        bestIndex = seg.index;
      }
    });

    const isOpen = getDrawType() === 'open';

    if (isOpen) {
      const vb = canvas.viewBox.baseVal;
      const nx = clamp(pos.x, 20, vb.width - 20);
      const ny = clamp(pos.y, 20, vb.height - 20);
      const last = drawPoints[drawPoints.length - 1];
      const dist = Math.hypot(nx - last.x, ny - last.y);

      if (dist < 10) return;

      if (bestIndex === segs.length - 1) {
        drawPoints.splice(bestIndex + 1, 0, { x: nx, y: ny });
        selectedPointIndex = bestIndex + 1;
        lastCreatedPointIndex = bestIndex + 1;
      } else {
        drawPoints.push({ x: nx, y: ny });
        selectedPointIndex = drawPoints.length - 1;
        lastCreatedPointIndex = drawPoints.length - 1;
      }

      redrawCanvas();
      rebuildSideInputs();
      return;
    }

    if (bestIndex !== -1) {
      drawPoints.splice(bestIndex + 1, 0, { x: pos.x, y: pos.y });
      selectedPointIndex = bestIndex + 1;
      lastCreatedPointIndex = bestIndex + 1;
      redrawCanvas();
      rebuildSideInputs();
    }
  });

  window.addEventListener('pointerup', () => {
    draggingPointIndex = null;
  });

  document.getElementById('rk-draw-type').addEventListener('change', () => {
    redrawCanvas();
    rebuildSideInputs();
    updateAutoSummary();
  });

  document.getElementById('rk-next-step').addEventListener('click', function () {
    if (!validateCurrentStep()) return;

    if (currentStep === totalSteps - 1) {
      currentStep = totalSteps;
      updateStepUI();

      requestAnimationFrame(() => {
        runCalculation();
      });
      return;
    }

    nextStep();
  });

  document.getElementById('rk-prev-step').addEventListener('click', prevStep);
  document.getElementById('rk-restart-footer').addEventListener('click', resetAll);

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('#rk-cart-result');
    if (!btn) return;
    if (!cartItems.length) return;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });

      if (!res.ok) throw new Error('Add to cart failed');

      closeDrawer();

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

      const mini = document.getElementById('mini-cart');
      if (mini) {
        mini.open = true;
      } else {
        const headerCartBtn = document.querySelector('.header__cart-toggle, [data-action="open-cart"], .site-header__cart');
        if (headerCartBtn) headerCartBtn.click();
      }
    } catch (err) {
      console.error(err);
      alert('Fehler beim Hinzufügen zum Warenkorb');
    }
  });

  updateFormUI();
  updateRoundHint();
  syncWidthSelects('main');
  updateCanvasViewBox();
  redrawCanvas();
  rebuildSideInputs();
  updateAutoSummary();
  updateStepUI();

  window.addEventListener('resize', () => {
    updateCanvasViewBox();
    redrawCanvas();
  });

  const canvasObserver = new ResizeObserver(() => {
  updateCanvasViewBox();
  redrawCanvas();
});

canvasObserver.observe(canvas);
})();